import { App } from "vue";
import UserFinderClass from "../../../src/user/application/user-finder";
import MultilingualServiceClass from "../../../libs/application/multilingual-service";

function has_allowed_role(roles: string[], allowed_roles: string[]): boolean {
	if (!Array.isArray(roles)) return false;
	return roles.some((role) => allowed_roles.includes(role));
}

export default {
	install: (app: App, options?: any): void => {
		app.config.globalProperties.$is_sentinel_user = (): boolean => {
			const UserFinder = new UserFinderClass();
			const current_user = UserFinder.get_stored_user();

			const sentinel_allowed_roles = [
				"supervisor",
				"manager",
				"guest",
				"maintainer"
			];

			return (
				Boolean(current_user) &&
				has_allowed_role(current_user.roles, sentinel_allowed_roles)
			);
		};

		app.config.globalProperties.$is_admin_user = (): boolean => {
			const UserFinder = new UserFinderClass();
			const current_user = UserFinder.get_stored_user();
			const bess_allowed_roles = ["admin"];

			return (
				Boolean(current_user) &&
				has_allowed_role(current_user.roles, bess_allowed_roles)
			);
		};

		app.config.globalProperties.$is_grid_user = (): boolean => {
			const UserFinder = new UserFinderClass();
			const current_user = UserFinder.get_stored_user();
			const grid_allowed_roles = ["2grid_supervisor"];

			return (
				Boolean(current_user) &&
				has_allowed_role(current_user.roles, grid_allowed_roles)
			);
		};

		app.config.globalProperties.$is_bess_user = (): boolean => {
			const UserFinder = new UserFinderClass();
			const current_user = UserFinder.get_stored_user();
			const bess_allowed_roles = ["bess_supervisor"];

			return (
				Boolean(current_user) &&
				has_allowed_role(current_user.roles, bess_allowed_roles)
			);
		};

		app.config.globalProperties.$check_and_set_default_languaje = (): void => {
			const MultilingualService = new MultilingualServiceClass();

			const cached_user_languaje = MultilingualService.get_user_app_lang();
			if (cached_user_languaje) return;

			const allowed_langauajes =
				MultilingualService.get_available_languages_codes();
			const web_browser_languaje = navigator.language.split("-")[0];

			const is_allowed_web_brower_languaje =
				allowed_langauajes.includes(web_browser_languaje);

			const user_lang = is_allowed_web_brower_languaje
				? web_browser_languaje
				: "es";

			MultilingualService.set_user_app_lang(user_lang);
		};
	}
};

declare module "@vue/runtime-core" {
	interface ComponentCustomProperties {
		$is_sentinel_user: () => boolean;
		$is_admin_user: () => boolean;
		$is_grid_user: () => boolean;
		$is_bess_user: () => boolean;
		$check_and_set_default_languaje: () => void;
	}
}
